<script lang="ts">
  interface Props {
    helpText?: string;
    index: number;
    params?: any[];
  }

  let { helpText = '', index, params = [] }: Props = $props();
</script>

{#if helpText && index !== 0 && params?.length === index + 1}
  <div class="helpText">{helpText}</div>
{/if}

<style>
  .helpText {
    color: var(--grey-dark);
    font-style: italic;
    margin-left: 6px;
  }
</style>
